/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Go_ListInputs */

const en_cmd_go_list = /** @type {(inputs: Cmd_Go_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to list`)
};

const de_cmd_go_list = /** @type {(inputs: Cmd_Go_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Liste`)
};

/**
* | output |
* | --- |
* | "Go to list" |
*
* @param {Cmd_Go_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_go_list = /** @type {((inputs?: Cmd_Go_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Go_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_go_list(inputs)
	return en_cmd_go_list(inputs)
});